<template>
  <validation-observer ref="formCompany" @change="submitForm">
    <b-form @submit.prevent>
      <b-row class="d-flex align-items-center">
        <!-- username -->
        <b-col cols="12" sm="10">
          <validation-provider
            rules="required"
            v-slot="{ errors }"
            name="Lead Source"
            vid="Lead Source"
          >
            <b-form-group label="Lead Source*" label-for="h-First">
              <b-form-select
                rules="required"
                v-model="company.profile.source"
                :options="sourceDDL"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" sm="2" class="d-flex align-items-center">
          <b-button
            variant="primary"
            class="w-100"
            @click="showModal('Source')"
          >
            Add Source
          </b-button>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Company Name*" label-for="h-company">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Company Name"
              vid="Company Name"
            >
              <b-form-input
                id="h-full"
                placeholder="Company Name"
                v-model="company.otherName"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button
            v-on:click="isCollapseComp = !isCollapseComp"
            variant="primary"
          >
            {{ this.isCollapseComp ? "See More" : "See Less" }}
          </b-button>
        </b-col>

        <b-col v-if="!isCollapseComp" cols="12">
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="Sales Person"
              vid="Sales Person"
            >
              <b-form-group label="Sales Person" label-for="h-First">
                <b-form-select
                  v-model="company.salesPersonId"
                  :options="optionsSalesPerson"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- email -->
          <b-col cols="12">
            <validation-provider
              rules="email_regex"
              v-slot="{ errors }"
              name="Email"
              vid="Email"
            >
              <b-form-group label="Email" label-for="d-email">
                <b-form-input
                  id="d-email"
                  type="email"
                  placeholder="Enter your email (e.g., example@domain.com)"
                  v-model="company.email"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Address Line 1" label-for="h-Address">
              <b-form-input
                id="h-Address"
                placeholder="Address"
                v-model="company.addressLine1"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Address Line 2" label-for="h-Street">
              <b-form-input
                id="h-Street"
                placeholder="Street Name"
                v-model="company.addressLine2"
              />
            </b-form-group>
          </b-col>

          <b-col cols="10">
            <b-form-group label="City" label-for="h-City">
              <b-form-select
                v-model="company.profile.city"
                :options="cityOptions"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('City')"
            >
              Add City
            </b-button>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Telephone" label-for="h-Telephone">
              <b-form-input
                id="h-Telephone"
                placeholder="Telephone"
                type="number"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                v-model="company.tel"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Category"
              label-for="h-SpecialInstructions"
            >
              <b-form-input
                id="h-SpecialInstructions"
                placeholder="Category"
                v-model="company.fieldInstruction"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Website" label-for="h-Website">
              <b-form-input
                id="h-Website"
                placeholder="Website"
                v-model="company.website"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="VAT Number" label-for="h-Number">
              <b-form-input
                id="h-Number"
                placeholder="VAT Number"
                v-model="company.vatNumber"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
              <b-form-group label="Company BRN" label-for="h-Number">
                <b-form-input
                  id="h-Number"
                  placeholder="Company BRN"
                  v-model="company.brn"
                />
              </b-form-group>
          </b-col>

          <b-col cols="10">
            <b-form-group label="Products Interested in" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Products Interested in"
                label="itemTitle"
                v-model="company.profile.productsInterestedIn"
                :options="productInterestOptions"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('ProductInterest')"
            >
              Add Product Interest
            </b-button>
          </b-col>
          <!-- Segment -->
          <b-col cols="12">
            <b-form-group label="Marketing Segment" label-for="h-title">
              <v-select
                multiple
                placeholder="Add Products Interested in"
                label="itemTitle"
                v-model="company.profile.marketingSegments"
                :options="segmentOptions"
              />
            </b-form-group>
          </b-col>
          <!-- Percentage -->
          <b-col cols="12">
            <b-form-group label="Percentage" label-for="d-percentage">
              <div class="input-group">
                <b-form-input
                  id="d-percentage"
                  type="number"
                  placeholder="Percentage"
                  v-model.number="company.percentage"
                  min="0"
                  max="100"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </b-form-group>
          </b-col>
        </b-col>
      </b-row>

      <CustomFieldsDetails
        v-if="!isCollapseComp"
        :AdditionalFields="company.additionalFields"
        :ModuleReference="'LeadClient'"
        @onchange="additionalFieldChanges"
      ></CustomFieldsDetails>
    </b-form>
    <b-modal :id="modalId" :title="modalTitle" hide-footer>
      <b-form @submit.prevent="addItem">
        <b-form-group
          :label="`Add ${modalTitle}`"
          label-for="input-new-item"
        >
          <b-form-input
            id="input-new-item"
            v-model="newItem"
            required
            placeholder="Enter new item"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Add</b-button>
      </b-form>

      <div class="p-1" style="max-height: 500px; overflow-y: auto">
        <b-table
          striped
          hover
          :items="modalOptions"
          responsive
          :fields="fields"
        >
          <template v-slot:cell(name)="data">
            {{
              modalType === "PRODUCTINTEREST"
                ? data.item.itemTitle
                : data.item.text
            }}
          </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              variant="danger"
              @click="deleteItem(data.item.value)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </div>
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormText,
  BDropdownItem,
  BFormTextarea,
  BDropdown,
  BFormDatalist,
  BFormSelect,
  BModal,
  VBModal,
  BTable,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { mapGetters, mapActions } from "vuex";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { ModuleReferenceList } from "@/libs/defaultList";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { fnSortingDropdown } from "@/libs/customFn";
import { extend } from "vee-validate";

extend("email_regex", {
  validate: value =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
  message: "Please enter a valid email address in the format example@domain.com",
});

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckbox,
    BForm,
    BFormText,
    BButton,
    BFormDatalist,
    BDropdownItem,
    BFormTextarea,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
    BModal,
    VBModal,
    BTable,
    CustomFieldsDetails,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },

  props: {
    company: {
      type: Object,
      default: () => ({
        source: null,
        specifySource: "",
      }),
    },
  },
  data() {
    return {
      fields: [{ key: "name", sortable: true }, { key: "actions" }],
      optionsSalesPerson: [],
      isCollapseComp: true,
      sourceOptions: [],
      productInterestOptions: [],
      cityOptions: [],
      previousCompany: null,
      modalId: "",
      modalTitle: "",
      modalType: "",
      newItem: "",
      currentOptions: [],
      socialMedias: [
        { text: "Facebook", value: 1 },
        { text: "Instagram", value: 2 },
        { text: "LinkedIn", value: 4 },
        //{ text: "Other", value: 0 },
        { text: "Twitter", value: 3 },
      ],
      selected: "Select Social Media",

      ////////
      required,
      email,
      moduleList: ModuleReferenceList,
    };
  },

  computed: {
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("customerModule", {
      details: "details",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    modalOptions() {
      if (this.modalType === "Product Interest") {
        return this.productInterestOptions;
      } else if (this.modalType === "Source") {
        return this.sourceOptions;
      } else if (this.modalType === "City") {
        return this.cityOptions;
      }
      return []; // Return an empty array as fallback
    },
    sourceDDL() {
      return fnSortingDropdown(this.sourceOptions);
    },
    // salesPersonDDL() {
    //   return fnSortingDropdown(this.optionsSalesPerson);
    // },
    cityDDL() {
      return fnSortingDropdown(this.cityOptions);
    },
    // jobTitleDDL() {
    //   return fnSortingDropdown(this.jobTitleOptions);
    // },
    // hobbiesDDL() {
    //   return fnSortingDropdown(this.hobbiesOptions);
    // },
    productInterestDDL() {
      return fnSortingDropdown(this.productInterestOptions);
    },
    segmentOptions() {
      // Assuming this.segments is the array containing segment data
      return this.segments.map((segment) => {
        return {
          value: segment.segmentId,
          itemTitle: segment.name,
        };
      });
    },
  },

  async mounted() {
    await this.loadAndRefreshDetails();
    // sourceDDL = fnSortingDropdown(this.sourceOptions);
    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName} ${v.lastName}`,
        })
      );
    });
    await this.getSegmentsAction()
      .then((response) => {})
      .catch((response) => {
        console.log(response);
      });
    await this.loadAndRefreshDetails();
    this.sourceOptions = fnSortingDropdown(this.sourceOptions);
    this.optionsSalesPerson = fnSortingDropdown(this.optionsSalesPerson);
    this.cityOptions = fnSortingDropdown(this.cityOptions);
    this.jobTitleOptions = fnSortingDropdown(this.jobTitleOptions);
    this.hobbiesOptions = fnSortingDropdown(this.hobbiesOptions);
    this.productInterestOptions = fnSortingDropdown(this.productInterestOptions);
    this.segmentOptions = fnSortingDropdown(this.segmentOptions);
  },

  methods: {
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("customerModule", [
      "getProfileDetailsListAction",
      "addProfileDetailAction",
      "deleteCustomerProfileDetailAction",
    ]),
    ...mapActions("segmentModule", [
      "getSegmentsAction",
      "removeSegmentAction",
      "addSegmentAction",
      "updateSegmentAction",
    ]),

    async loadAndRefreshDetails() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the details are loading...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      const typeArrays = {
        SOURCE: this.sourceOptions,
        PRODUCTINTEREST: this.productInterestOptions,
        CITY: this.cityOptions,
      };

      await this.getProfileDetailsListAction().then((response) => {
        for (const [type, optionsArray] of Object.entries(typeArrays)) {
          const filteredData = this.details.filter(
            (item) => item.type === type
          ).sort((a, b) => a.name.localeCompare(b.name));
          optionsArray.splice(
            0,
            optionsArray.length,
            ...filteredData.map((item) => ({
              value: item.id,
              text: item.name,
              itemTitle: type === "PRODUCTINTEREST" ? item.name : undefined,
            }))
          );
          console.log(`Updated ${type} Options:`, optionsArray); // Debugging line
        }
      });
      this.$swal.close();
    },
    showModal(type) {
      this.modalType = type;
      this.modalId = `modal-${type.toLowerCase()}`;
      this.modalTitle = this.getModalTitle(type);

      this.currentOptions = this[`${type.toLowerCase()}Options`];
      this.$nextTick(() => {
        this.$bvModal.show(this.modalId);
      });
    },
    getModalTitle(type) {
    switch (type.toLowerCase()) {
      case "hobbie":
        return "Hobbies";
      case "productinterest":
        return "Product Interest";
      case "city":
        return "City";
      case "jobtitle":
        return "Job Title";
      case "source":
        return "Source";
      default:
        return "Unknown Type";
    }
  },
    addItem() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being added...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      // Validate character limits for "JOBTITLE" and "SOURCE" types
      if (
        (this.modalType === "JOBTITLE" && this.newItem.length > 100) ||
        (this.modalType === "SOURCE" && this.newItem.length > 50)
      ) {
        // Show SweetAlert if character limit is exceeded
        this.$swal({
          title: "Error!",
          text:
            this.modalType === "JOBTITLE"
              ? "Job title should not exceed 100 characters."
              : "Source should not exceed 50 characters.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      const payload = {
        name: this.newItem,
        type: this.modalType,
      };

      this.addProfileDetailAction(payload)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item added successfully!");
          this.newItem = "";
          this.$bvModal.hide(this.modalId);
        })
        .catch((error) => {
        // console.log(error);
        console.log("This is an error: ", error);
         // Extract error message from the API response
      let errorMsg = "Failed to add item.";
      if (error.response?.data?.message) {
        errorMsg = error.response.data.message; // This ensures we show the correct backend error
      }

      // Display the error message using SweetAlert
      this.$swal({
        title: "Error!",
        text: errorMsg,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    });
      this.newItem = "";
      this.$bvModal.hide(this.modalId);
    },

    deleteItem(value) {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being deleted...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.deleteCustomerProfileDetailAction(value)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item deleted successfully!");
        })
        .catch((error) => {
          this.showErrorAlert("Failed to delete item: " + error.message);
          this.$swal.close();
        });
        // sourceDDL = fnSortingDropdown(this.sourceOptions);
    },

    saveSocialMedia(value, text) {
      this.company.source = value;
      this.selected = text;
    },

    resetForm() {
      this.$refs.formCompany.reset();
    },
    async submitForm() {
      if (!(await this.$refs.formCompany.validate())) {
        return;
      }

      //emit the data to another page
      this.company.companyName = this.company.otherName;
      this.$emit("onchange", this.company);
      let isValid = await this.$refs.formCompany.validate();
      return isValid;
    },

    showErrorAlert(errorMessage) {
      this.$swal({
        title: "Error!",
        text:
          errorMessage || "An error occurred while adding the profile detail",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    showSuccessAlert(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    additionalFieldChanges(customFields) {
      this.company.additionalFields = customFields;
    },
  },
  watch: {
    company: {
      handler(newVal) {
        if (
          !(JSON.stringify(this.previousCompany) === JSON.stringify(newVal))
        ) {
          this.$emit("update:company", newVal);
          this.previousCompany = newVal;
        }
      },
      deep: true,
    },
    "company.percentage"(value) {
      if (value < 0 || value > 100) {
        this.company.percentage = 0;
        // Display a sweet alert to inform the user about the percentage range
        this.$nextTick(() => {
          this.$swal.fire({
            title: "Invalid Percentage",
            text: `Please enter a value between 0 to 100.`,
            icon: "warning",
            confirmButtonText: "OK",
          });
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
